import { IClient } from "@interfaces";
import { Card, Divider, Space } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
interface Iprops {
  loading: boolean;
  client?: IClient;
}
export const ComponentCdicClient = ({ loading, client }: Iprops) => {
  const { t } = useTranslation();
  return (
    <StyledCard title={t("page.patient_information")} bordered={false} loading={loading}>
      <Space>
        <p>{t("page.name_label")}</p>
        <p>{client?.name}</p>
      </Space>
      <Divider />
      <Space>
        <p>{t("page.age_label")}</p>
        <p>{dayjs().diff(client?.dateOfBirth, "years")}</p>
      </Space>
      <Divider />
      <Space>
        <p>{t("page.insulin_type")}</p>
        <p>{client?.insulinType}</p>
      </Space>
      <Divider />
      <Space>
        <p>{t("page.hospital_name")}</p>
        <p>{client?.hospitalName}</p>
      </Space>
      <Divider />
      <Space>
        <p>{t("page.contact_phone_number_label")}</p>
        <p>{client?.phoneNumber}</p>
      </Space>
      <Divider />
    </StyledCard>
  );
};
const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  .ant-space {
    display: flex;
    justify-content: space-between;
  }
`;
